import { isUndefined } from 'lodash';

import { computed, Ref, set } from '@vue/composition-api';
import { createEventHook } from '@vueuse/core';

import { IssueAssembleResponse, Sprint } from '../models/issue';
import { ActionStore } from './action';
import { OptionItem } from '../models/field';

export const useSprint = (
  actionStore: ActionStore,
  issueAssemble: Ref<IssueAssembleResponse | null>,
  getFieldStore: () => any
) => {
  const sprints = computed(() => {
    const options: Sprint[] = getFieldStore().optionsMap.value.sprint || [];
    // 获取Issue组装的 sprintVOList
    const issueSprints = issueAssemble.value?.sprintVOList || [];
    // 用于填充最终 Sprint 数组的 Map，确保id的唯一性
    const sprintsMap = new Map<number, Sprint>();
    // 先添加 issueSprints 中的项
    issueSprints.forEach(sprint => {
      sprintsMap.set(sprint.id, sprint);
    });

    // 然后添加 options 中独有的项
    options.forEach((option) => {
      if (!sprintsMap.has(option.id!)) {
        sprintsMap.set(option.id, {
          ...option,
          status: option.extendValue
        });
      }
    });

    // 将 Map 转换回数组
    return Array.from(sprintsMap.values());
  });
  const sprintChangedEvent = createEventHook<number | null>();

  const currentSprintId = computed(() => {
    const filedStore = getFieldStore();
    if (actionStore.action.value?.type === 'Create') {
      if (isUndefined(filedStore.fieldValues.value.sprint)) {
        return actionStore.action.value.sprintId ?? null;
      }
      return filedStore.fieldValues.value.sprint as number | null;
      // eslint-disable-next-line no-else-return
    } else if (
      actionStore.action.value?.type === 'Edit' ||
      actionStore.action.value?.type === 'PreviewType'
    ) {
      return filedStore.fieldValues.value.sprint as number | undefined;
    }
    return undefined;
  });

  return {
    sprints,
    currentSprint: computed<Sprint | undefined>(() => {
      if (currentSprintId.value) {
        const findSprint = sprints.value.find(
          (t) => t.id === currentSprintId.value
        );
        if (findSprint) {
          return findSprint;
        }

        if (
          issueAssemble.value?.issueVO?.data.sprintVO?.id ===
          currentSprintId.value
        ) {
          return issueAssemble.value?.issueVO.data.sprintVO;
        }
      }
      return undefined;
    }),
    currentSprintId,
    onSprintChanged: sprintChangedEvent.on,
    setSprint: (val: number | null) => {
      if (
        actionStore.action.value?.type === 'Create' ||
        actionStore.action.value?.type === 'PreviewType'
      ) {
        const filedStore = getFieldStore();
        set(filedStore.fieldValues.value, 'sprint', val);
        filedStore.flushChanges();
      } else if (actionStore.action.value?.type === 'Edit') {
        const filedStore = getFieldStore();
        set(filedStore.fieldValues.value, 'sprint', val);
        filedStore.flushChanges();
      }
      sprintChangedEvent.trigger(val);
    }
  };
};

export type SprintStore = ReturnType<typeof useSprint>;
